export default defineAppConfig({
  theme: {
    primaryColor: "customPrimary",
  },
  ui: {
    primary: "customPrimary",
    gray: "cool",
    
  },
});
